import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"

export default function useGetWeeklyObjectivesApproval(id: string) {
  return useQuery({
    queryKey: ["weekly-objectives-approval", id],
    queryFn: () => api.cronos.weeklyObjectives.getWeeklyObjectiveApproval(id),
    enabled: !!id,
  })
}
